import { render, staticRenderFns } from "./EbLinkButton.vue?vue&type=template&id=58260d04"
import script from "./EbLinkButton.vue?vue&type=script&lang=js"
export * from "./EbLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports